// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__QVYq_","contentWrapper":"styles_contentWrapper__eRU8M"};